import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import "./WhatsAppChat.css";
import { useSelector, useDispatch } from "react-redux";
import { appSetup } from "../../features/master/masterSlice";

const WhatsAppChat = () => {

  const app_setup = useSelector((state) => state.master.app_setup);
  return (
    <a
      href={`https://wa.me/91${app_setup?.alt_contact_no}`}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-chat"
    >
      <FaWhatsapp />
    </a>
  );
};

export default WhatsAppChat;